import type {ReactElement} from 'react'

import {type SlotWidgetConfig, WidgetType} from '../types'
import {Slot} from './Slot'

const isRadio = (type?: string): type is WidgetType.RADIO => type === WidgetType.RADIO

/**
 * Виджет слота.
 */
export const SlotWidget = (props: SlotWidgetConfig): ReactElement => {
  // Если в хвосте слота есть радиобаттон, делаем весь слот кликабельным
  if (isRadio(props.slot.trail1?.type) || isRadio(props.slot.trail2?.type)) {
    return (
      <label>
        <Slot {...props} />
      </label>
    )
  }

  return <Slot {...props} />
}
